import React, { Component } from "react";

class Footer extends Component {
  state = {};
  render() {
    return (
      <div className="footer-container">
        <div><span className="rose-color">&copy;</span> 2019 JOlsonDigital All rights reserved</div>
      </div>
    );
  }
}

export default Footer;
